export default __webpack_public_path__ + "static/media/biking.4fccd473.gif";